import React, { Component } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';

import { SubmitButton } from '../forms/FormItems';
import { CheckIcon, StatExpiredIcon, StatListIcon } from '../images/icons';
import { confirmState, errorState, feedbackModel, uistate } from '../stores/common';
import { getErrorText } from '../functions';

export const InlineError = ({ ErrorCode, Success = false }) => ErrorCode
	? <p className={"inlineFeedback " + (Success ? "success" : "error")}>
		{Success ? <CheckIcon /> : <StatExpiredIcon />}
		<span>{getErrorText(ErrorCode)}</span>
	</p>
	: null;

export const OpenShiftInformer = ({ Text = "Для работы с данным разделом откройте смену" }) =>
	<div className="shiftInformer">
		<span className="feedbackIcon"><StatExpiredIcon /></span>
		<span>{Text}</span>
	</div>;

/** Информер пустого результата запроса */
export const EmptyResultInformer = ({
	Text = "По вашему запросу ничего не найдено",
	Description
}) =>
	<div className="section emptyResultInformer">
		<span className="iconSvg"><StatListIcon /></span>
		<div>
			<p>{Text}</p>
			{Description && <span>{Description}</span>}
		</div>
	</div>;

/** Универсальное модальное окно с формой и общими кнопками подтверждения и отмены */
export class FormModal extends Component {
	componentDidMount() {
		document.addEventListener("keydown", this.onKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.onKeyDown);
	}

	/** Закрытие формы по Escape */
	onKeyDown = (event) => {
		const errorOpen = !_.isNull(errorState.ErrorText) && errorState.ErrorText !== "";
		if (event.key === "Escape" && !confirmState.ConfirmOpen && !errorOpen) this.onClose();
	}

	/** Закрытие формы по клику на фон */
	onBackClick = (event) => {
		if (event.target === event.currentTarget) this.onClose();
	}

	/** Закрытие формы */
	onClose = (event) => {
		if (event) event.preventDefault();
		const onClose = this.props.onClose;
		if (onClose) onClose();
	}

	/** Отправка формы без стандартной перезагрузки страницы */
	onSubmit = (event) => {
		event.preventDefault();
		if (this.props.onSubmit) this.props.onSubmit();
	}

	render() {
		return(
			<div className="back" onClick={this.onBackClick}>
				<div
					id={this.props.Id}
					className={"confirmBlock window form formModal " +
						(this.props.ClassName ? this.props.ClassName + " " : "") +
						(uistate.IsMobile ? "mobile" : "")}
				>
					{!this.props.onSubmit &&
						<a href="/" className="hide" onClick={this.onClose}>Нажмите, чтобы закрыть окно</a>
					}
					{this.props.Title && <h3>{this.props.Title}</h3>}
					<form onSubmit={this.onSubmit}>
						<div className="formModalContent">{this.props.children}</div>
						{this.props.onSubmit &&
							<div className="buttons">
								<SubmitButton Loading={this.props.Loading} Title={this.props.SubmitTitle || "Подтвердить"} />
								<button type="button" onClick={this.onClose} className="button secondary">
									{this.props.CancelTitle || "Закрыть"}
								</button>
							</div>
						}
					</form>
				</div>
			</div>
		)
	}
}
FormModal = observer(FormModal);

export class Confirm extends Component {
	componentDidMount() {
		document.addEventListener("keydown", this.onKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.onKeyDown);
	}

	/** Закрытие подтверждения по Escape, если поверх него нет окна с ошибкой */
	onKeyDown = (event) => {
		const errorOpen = !_.isNull(errorState.ErrorText) && errorState.ErrorText !== "";
		if (event.key === "Escape" && confirmState.ConfirmOpen && !errorOpen) {
			event.preventDefault();
			event.stopImmediatePropagation();
			this.closeConfirm();
		}
	}

	closeConfirm = () => {
		if (confirmState.ConfirmCancel) confirmState.ConfirmCancel();
		confirmState.closeConfirm();
	}

	onCancel = (event) => {
		event.preventDefault();
		this.closeConfirm();
	}

	onConfirm = (event) => {
		event.preventDefault();
		confirmState.submitConfirm();
	}

	render() {
		if (!confirmState.ConfirmOpen) return null;

		return(
			<div className="back">
				<div className={"confirmBlock feedbackConfirm window " + (uistate.IsMobile ? "mobile" : "")}>
					<div className="title">
						<span className="feedbackIcon"><StatExpiredIcon /></span>
						<h4>Подтвердите действие</h4>
					</div>
					<p>{confirmState.ConfirmText}</p>
					{confirmState.ConfirmComment && <p className="comment">{confirmState.ConfirmComment}</p>}
					<form className="buttons" onSubmit={this.onConfirm}>
						<SubmitButton Loading={confirmState.ButtonLoading} Title="Подтвердить" />
						<a href="/" role="button" onClick={this.onCancel} className="button secondary">Отменить</a>
					</form>
				</div>
			</div>
		)
	}
}
Confirm = observer(Confirm);

export class ErrorMessage extends Component {
	componentDidMount() {
		document.addEventListener("keydown", this.onKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.onKeyDown);
	}

	/** Закрытие верхнего окна с ошибкой по Escape */
	onKeyDown = (event) => {
		const errorOpen = !_.isNull(errorState.ErrorText) && errorState.ErrorText !== "";
		if (event.key === "Escape" && errorOpen) {
			event.preventDefault();
			event.stopImmediatePropagation();
			this.closeError();
		}
	}

	closeError = () => {
		if (errorState.OnClose) errorState.OnClose();
		errorState.ErrorText = null;
		errorState.ErrorTitle = null;
	}

	/** Закрытие окна с ошибкой */
	onClick = (event) => {
		event.preventDefault();

		if (event.target.className === "back" || event.target.className === "hide") this.closeError();
	}

	render() {
		if (_.isNull(errorState.ErrorText) || errorState.ErrorText === "") return null;

		return(
			<div id="errorMessage" className="back" onClick={this.onClick}>
				<div className={"message " + (errorState.ErrorType ? "error" : "success")}>
					<a href="/" className="hide" onClick={this.onClick}>Нажмите, чтобы закрыть окно</a>
					<div className="title">
						<span className="feedbackIcon">
							{errorState.ErrorType ? <StatExpiredIcon /> : <CheckIcon />}
						</span>
						<h4>{errorState.ErrorTitle ||
							(errorState.ErrorType ? "Произошла ошибка" : "Успех!")}</h4>
					</div>
					<p>{errorState.ErrorText}</p>
				</div>
			</div>
		)
	}
}
ErrorMessage = observer(ErrorMessage);

export class FeedbackModal extends Component {
	componentDidMount() {
		document.addEventListener("keydown", this.onKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.onKeyDown);
	}

	onKeyDown = (event) => {
		if (event.key === "Escape" && feedbackModel.ModalOpen) feedbackModel.closeModal();
	}

	onClose = (event) => {
		event.preventDefault();
		feedbackModel.closeModal();
	}

	onBackClick = (event) => {
		if (event.target === event.currentTarget) feedbackModel.closeModal();
	}

	render() {
		if (!feedbackModel.ModalOpen) return null;

		return(
			<div className="back" onClick={this.onBackClick}>
				<div className={"feedbackModal window " + (uistate.IsMobile ? "mobile" : "")}>
					<a href="/" className="hide" onClick={this.onClose}>Нажмите, чтобы закрыть окно</a>
					<h4>{feedbackModel.ModalTitle}</h4>
					<div className="content">{feedbackModel.ModalContent}</div>
				</div>
			</div>
		)
	}
}
FeedbackModal = observer(FeedbackModal);
